import { City } from './city';
import { Company } from './company';

export class Location {
    refNo: number;
    locationName: string;
    parentLocationName: string;
    parentCompanyCode: number
    parentLocationCode: number
    pin: string;
    mobile: string;
    latitude: string
    longitude: string
    city: City;
    company: Company = new Company();
    parentLocation: Location;

    isParentLocation: boolean;

    allowBilling?: boolean;

    allowSaleInvoice?: boolean;

    companyCode: number;
    companyName: string;
}
